import { mapGetters } from "vuex"
import some from 'lodash/some'
//import filter from 'lodash/filter'
import find from 'lodash/find'
import intersection from 'lodash/intersection'
import get from 'lodash/get'

const InstructorAbilities = {

  computed: {
    ...mapGetters({
      //- Map using aliases to avoid name clashes
      iaMixGetProfessionById: 'basic/getProfessionById',
      iaMixSystemSettings: 'basic/systemSettings',
      iaMixCurrentUser: 'currentuser/currentUser',
    })
  },

  methods: {

    /* instructor: object
        {
          apprentices: [<obj>, ...],
          employed: {
            tradeCertificates: [<obj>, ...],
            instructorExemptions: [<obj>, ...],
            machinequalifications: [<obj>, ...]
          }
        }

       professionId: number
       machineQualificationIds: [number, number]
    */

    needToReadInstructor() 
    {            
      if (!(this.iaMixCurrentUser && this.iaMixCurrentUser.tradeCertificates && this.iaMixCurrentUser.tradeCertificates.length>0)) {
        return true;
      }
      const item = this.iaMixCurrentUser.tradeCertificates[0]

      if (item && item.readInstructionsOn) {
        const profession = this.iaMixGetProfessionById(item.professionId);
  
        if (profession && profession.newInstructionsAt) {  
          return Boolean(item.readInstructionsOn < profession.newInstructionsAt);
        }
      }
      return true;
    },

    canHaveAnotherApprentice(instructor, professionId, machineQualificationIds = [], GU = true) {      

      /* Expects instructor to be (minimum) like
        {
          apprentices: [{education: {basicEducationCertificate: { ... }}}],
          employed: {
            tradeCertificates: [{professionId: 1}], 
            instructorExemptions: [{professionId: 2, status: "unapproved"}], 
            machinequalifications: [{machineId: 4}, {machineId: 5}]
          }
        },
      */
      //console.log(instructor.employed.firstName, "listEmployments::", instructor)      

      const maxApprenticesForInstructorTotal = 3
      const scaffoldingApprenticeInGu = instructor.apprentices.find(a => 
        (a.profession && a.profession.id=='848' && a.education && a.education.basicEducationCertificate===null))
      const anotherScaffoldingApprenticeInGu = Boolean(scaffoldingApprenticeInGu && professionId=='848' && GU)
      //let professionObj = this.iaMixGetProfessionById(professionId)
      
      //- Check num of apprentices to see if we can have another
      const canHaveAnother =
        anotherScaffoldingApprenticeInGu ? false : 
          (
            //- Other professions can have maxApprenticesForInstructor in both GU and Ktid
            Boolean(instructor.apprentices.length < maxApprenticesForInstructorTotal)
          )

      //- Check certificates
      const haveCerts = this.haveCertificates(instructor, professionId, machineQualificationIds, GU)
      //console.log(canHaveAnother, "haveCerts::", haveCerts)
      return Boolean(canHaveAnother && haveCerts)
    },

    haveCertificates(instructor, professionId, machineQualificationIds = [], GU = true) {

      /* Expects instructor to be (minimum) like
        {
          employed: {
            tradeCertificates: [{professionId: 1}], 
            instructorExemptions: [{professionId: 2, status: "unapproved"}], 
            machinequalifications: [{machineId: 4}, {machineId: 5}]
          }
        },
      */

      const professionObj = this.iaMixGetProfessionById(professionId)
      professionObj.isScaffoldingProfession = Boolean(professionId == '848')
      // NOTICE - Only _really_ checks for cerificates when GU===true and for machine professions
      let hasValidIE = false
      let hasValidTC = false
      let hasValidMachines = false

      //- If it's a machine profession - instructor will need all machines that apprentice wants
      if (professionObj.isMachineProfession && get(instructor, 'employed.machinequalifications', []).length > 0) {
        const now = new Date()
        const activeMQs = get(instructor, 'employed.machinequalifications', []).filter(mq => {
          return mq.approvedById && (!mq.validTo || new Date(mq.validTo) > now)
        })
        hasValidMachines = Boolean(intersection(activeMQs.map(mq => mq.machineId), machineQualificationIds).length === machineQualificationIds.length)
      }

      //- Check for Trade certificates
      if (instructor.employed && instructor.employed.tradeCertificates) {
        hasValidTC = some(instructor.employed.tradeCertificates, ['professionId', professionObj.id])
      }

      //- Check for Instructor exemption
      if (instructor.employed && instructor.employed.instructorExemptions) {
        const now = new Date()
        hasValidIE = some(instructor.employed.instructorExemptions, ie => {
          if (!(ie.professionId === professionObj.id && ie.status === 'approved')) return false
          if (ie.guarantorPersonId) {
            const guarantorMqs = get(ie, 'guarantor.machinequalifications', [])
            const activeGuarantorMqs = guarantorMqs.filter(mq =>
              mq.approvedById && (!mq.validTo || new Date(mq.validTo) > now)
            )
            return machineQualificationIds.every(mid =>
              activeGuarantorMqs.some(mq => mq.machineId === mid)
            )
          }
          return true
        })
      }

      //- I case of GU and K-tid and the profession is scaffolding - instructor will need a certificate or an exemption
      if (professionObj.isScaffoldingProfession)
      {
        return Boolean(hasValidTC || hasValidIE)
      }

      //- I case of GU and it's a machine profession - instructor will need a certificate or an exemption
      if (professionObj.isMachineProfession && GU) {
        return Boolean((hasValidTC || hasValidIE) && hasValidMachines)
      }

      //- I case of machine profession OR GU - instructor will need a certificate or an exemption
      if (professionObj.isMachineProfession || GU) {
        return Boolean((hasValidTC || hasValidIE))
      }
      
      //- Else (ie. K-tid and not a machine profession) - anyone can be instructor
      return true
    },

    canApproveEbook(professionId) {                  
      // Check exemptions

      var hasValidIE = false
      if (this.iaMixCurrentUser && this.iaMixCurrentUser.instructorExemptions) {
        hasValidIE = some(this.iaMixCurrentUser.instructorExemptions, ['professionId', professionId])
        if (hasValidIE) {
          return {result: true, reason: null}
        }
      }
      //- Check tradecertificates
      var hasValidTC = false
      
      if (this.iaMixCurrentUser && this.iaMixCurrentUser.tradeCertificates) {
        hasValidTC = find(this.iaMixCurrentUser.tradeCertificates, ['professionId', professionId])
      }

      if (hasValidTC) {        

        const lastReadInstructions = this.iaMixCurrentUser.readInstructionsOn
        //If newInstructionsAt is in the future then return true, otherwise the instructor can never approve.
        const newInstructionsAt = (new Date(this.iaMixSystemSettings.newInstructionsAt) > new Date()) ? this.iaMixCurrentUser.readInstructionsOn : this.iaMixSystemSettings.newInstructionsAt
        if (lastReadInstructions) {        
          let shouldReadInstructions = lastReadInstructions >= newInstructionsAt          
          return {result: shouldReadInstructions, reason: null}
        }
        
        return {result: false, reason: this.$t("errors.not-read-instructions")}
      }      
      
      return {result: false, reason: this.$t("errors.no-certificate")}
    }

    //- More methods here?
  }
}

export default InstructorAbilities

